import { useEffect, useState } from "react";

import useMediaQuery from "@mui/material/useMediaQuery";

// Hook which returns the correct styles to apply to a dropdown component on an OL Map Component
// Used primarily to anchor dropdown elements to an element without it overlapping on all screensizes

const useMapDropdownStyles = (anchorElement) => {
    const [styles, setStyles] = useState({});

    const isDesktop = useMediaQuery("(min-width:600px)");

    useEffect(() => {
        if (!anchorElement) return;

        let newStyles = {};
        if (isDesktop) {
            const { bottom } = anchorElement.getBoundingClientRect();
            newStyles = { top: `${bottom + 8}px !important`, maxHeight: `calc(100% - ${bottom + 24}px)`, maxWidth: "300px" };
        } else {
            newStyles = { right: `42px !important`, maxWidth: "300px", width: "calc(100% - 48px)", left: "unset !important" };
        }
        setStyles(newStyles);
    }, [anchorElement, isDesktop]);

    return styles;
};

export default useMapDropdownStyles;
